// src/utils/seoKeywords.js

export const serviceKeywords = {
  "logistics": {
    hy: ["Ֆուռերի դատարկում", "Բեռնաթափում", "Պահեստի բանվորներ", "Բեռնաթափման աշխատանքներ"],
    en: ["Truck unloading", "Warehouse logistics Armenia", "Cargo handling"],
    ru: ["Разгрузка фур", "Услуги грузчиков", "Складская логистика"],
    slang: ["fura datarkum", "fureri bernatapum", "fura tapel", "furi razgruzka", "gruzshik", "furi banvor"]
  },
  "moving": {
    hy: ["Բեռնափոխադրում", "Տեղափոխում", "Կահույքի տեղափոխում", "Տան տեղափոխում"],
    en: ["Moving services Yerevan", "Furniture moving", "Truck taxi"],
    ru: ["Грузоперевозки Ереван", "Переезд офиса", "Грузовое такси"],
    slang: ["bernapoxadrum", "gazel taxi", "bernatar taxi", "texapoxum", "mebel texapoxel", "gruzavoy taxi"]
  },
  "waste": {
    hy: ["Շինաղբի հեռացում", "Աղբի տեղափոխում", "Շինարարական աղբ"],
    en: ["Waste removal", "Construction debris removal"],
    ru: ["Вывоз мусора", "Вывоз строительного мусора"],
    slang: ["shinaxbi heracum", "musor tapel", "zil", "kamaz", "musori mashin"]
  },
  // Default տվյալներ գլխավոր էջի կամ անհայտ սլագների համար
  "default": {
    hy: ["Liber Group", "Բեռնափոխադրում և Լոգիստիկա", "Բանվորական ուժ"],
    en: ["Liber Group", "Logistics and Moving Services"],
    ru: ["Liber Group", "Грузоперевозки и Логистика"],
    slang: ["liber am", "liber group armenia", "logistics am"]
  }
};